import { useEffect } from 'react';
import { useTranslation } from '../../context/translationContext';
import { searchByQuery } from '../../utils/functions/data.functions';

interface Props {
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
  includedFields?: string[];
  query: string;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
}

/**
 * Component for filtering table records by query
 * if included fields are not specified search trough all fields
 */
export const FulltextSearch = ({ data, setData, includedFields, query, setQuery }: Props) => {
  const { t } = useTranslation();
  /**
   * Search by query
   * @param query
   */
  const handleSearchByQuery = (query: string) => {
    if (!data) return;
    setQuery(query);
    setData(searchByQuery(query, data, includedFields));
  };

  useEffect(() => {
    handleSearchByQuery(query);
  }, [query, data]);

  return (
    <input
      placeholder={t('general.search')}
      type="text"
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      className="block m-auto p-2 text-sm text-gray-900 rounded-md border border-gray-600 focus:outline-none focus:ring-0 focus:border-gray-600"
    />
  );
};
